import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((_, { rows, wordBreak, hyphens, maxWidth })=>({
        ellipsis: {
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            display: '-webkit-box !important',
            WebkitLineClamp: rows,
            WebkitBoxOrient: 'vertical',
            overflowWrap: 'break-word',
            wordBreak: wordBreak,
            whiteSpace: 'normal',
            hyphens: hyphens ? 'auto' : 'none',
            maxWidth: maxWidth
        }
    }));
const EllipsisText_styles = useStyles;
export default EllipsisText_styles;
